/**
 * A function to strongly-type an inlined data structure.
 * See more at https://stackoverflow.com/a/54837072/678505
 */
export const strictType = <T>(x: T) => x;
